import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Grid from "core/Grid";
import colors from "core/colors";

import {
    Container,
    IconContainer,
    TextContainer,
    StyledHeading,
    StyledBodyText
} from "./styles";

const UnstyledBulletLeft = ({ className, bullets }) => {
    return (
        <Grid
            className={className}
            mobileSpacing={48}
            tabletSpacing={20}
            desktopSpacing={48}
        >
            {bullets.map((bullet, index) => (
                <Grid item sm={12} md={4} lg={4} key={index}>
                    <Container>
                        <IconContainer>{bullet.icon}</IconContainer>
                        <TextContainer>
                            <StyledHeading
                                type="div"
                                size="xs"
                                headingColor={colors.secondary.orca}
                            >
                                {bullet.title}
                            </StyledHeading>

                            <StyledBodyText
                                type="div"
                                size="sm"
                                copyColor={colors.secondary.orca}
                            >
                                {bullet.text}
                            </StyledBodyText>
                        </TextContainer>
                    </Container>
                </Grid>
            ))}
        </Grid>
    );
};

const BulletLeft = styled(UnstyledBulletLeft)``;

BulletLeft.propTypes = {
    bullets: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element,
            title: PropTypes.string,
            text: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
        })
    ).isRequired
};

export default BulletLeft;
